<div class="picker"
     role="dialog"
     [attr.aria-label]="'settings.admin_search_picker.search_admin_sections' | transloco"
     [style.top.px]="anchor()?.top ?? null"
     [style.right.px]="anchor()?.right ?? null"
     [class.picker--anchored]="anchor() !== null"
     (click)="$event.stopPropagation()">
  <div class="picker-header">
    <paper-icon name="search" [size]="14" aria-hidden="true" />
    <input #queryInput
           class="picker-search"
           type="text"
           [placeholder]="'settings.admin_search_picker.search_admin_try_catering_audit_alerts' | transloco"
           [ngModel]="query()"
           (ngModelChange)="onQueryChange($event)"
           (keydown)="onKeydown($event)"
           [attr.aria-label]="'settings.admin_search_picker.search_admin_sections_2' | transloco" />
    <kbd class="picker-kbd">esc</kbd>
  </div>

  <ul class="picker-list" role="listbox">
    @for (group of grouped(); track $index) {
      @if (group.headingKey) {
        <li class="picker-heading" role="presentation">{{ group.headingKey | transloco }}</li>
      }
      @for (section of group.items; track section.url) {
        <li role="option"
            class="picker-item"
            [class.focused]="results()[cursor()] === section"
            [attr.aria-selected]="results()[cursor()] === section"
            (mouseenter)="onMouseEnter(results().indexOf(section))"
            (click)="onClick(section)">
          <span class="picker-icon" aria-hidden="true">
            <paper-icon [name]="section.icon" [size]="14" />
          </span>
          <span class="picker-text">
            <span class="picker-title">{{ (section.labelKey | transloco) || section.label }}</span>
            @if (section.descriptionKey || section.description) {
              <span class="picker-desc">{{ (section.descriptionKey | transloco) || section.description }}</span>
            }
          </span>
        </li>
      }
    }
    @if (!results().length) {
      <li class="picker-empty">{{ 'settings.admin_search_picker.no_sections_match_query' | transloco:{ query: query() } }}</li>
    }
  </ul>

  <div class="picker-footer">
    <span><kbd>&uarr;</kbd><kbd>&darr;</kbd> {{ 'settings.admin_search_picker.navigate' | transloco }}</span>
    <span><kbd>&crarr;</kbd> {{ 'settings.admin_search_picker.open' | transloco }}</span>
  </div>
</div>
